import { connect } from 'react-redux';
import WasteBalancing from './WasteBalancing';
import { getWasteRolls } from '../../store/actions/waste';
import { getReportCreate } from '../../store/actions/report';

const mapStateToProps = ({
  wasteReducer,
  tabsReducer,
  reportReducer
}) => ({
  wasteReducer,
  tabsReducer,
  reportReducer
});

const mapDispatchToProps = {
  getWasteRolls,
  getReportCreate
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WasteBalancing);
